import { useTranslation } from 'react-i18next';
import { MasterListJournal } from '../../../types/MasterList.types';
import {
  isStatusAdded,
  isStatusCeased,
  isStatusDeleted,
} from '../utils/status';

interface UseMasterListJournalUiStateParams {
  editMode: boolean;
  journal?: MasterListJournal;
  requiredFieldsMissing: boolean;
  hasChanges: boolean;
}

export const useMasterListJournalFormState = ({
  editMode,
  journal,
  requiredFieldsMissing,
  hasChanges,
}: UseMasterListJournalUiStateParams) => {
  const { t } = useTranslation();

  const isDeleted = editMode && isStatusDeleted(journal?.status);
  const isCeased = editMode && isStatusCeased(journal?.status);
  const isAdded = editMode && isStatusAdded(journal?.status);

  const isReadonly = isDeleted || isCeased;
  const showHeaderActions = editMode && !isCeased;
  const showDeleteButton = showHeaderActions && !isDeleted && !isAdded;
  const showSaveButton = !isReadonly;
  const cancelLabel = isCeased ? t('masterList.close') : t('masterList.cancel');
  const canSave =
    !requiredFieldsMissing && !isReadonly && (!editMode || hasChanges);
  const showAsteriskSubtitle = !isReadonly;

  return {
    isDeleted,
    isCeased,
    isAdded,
    isReadonly,
    showHeaderActions,
    showDeleteButton,
    showSaveButton,
    cancelLabel,
    canSave,
    showAsteriskSubtitle,
  };
};
